import {Flag, FormControl, FormField} from 'platform/components';
import {Box, Grid, GridItem, HStack, Icon} from 'platform/foundation';
import {match} from 'ts-pattern';

import {Path} from 'react-hook-form';

import {always} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {ReceiveNoteCorrectionItemForm} from '../types/ReceiveNoteCorrectionItemForm';
import {ReceiveNoteCorrectionItemFormContext} from '../types/ReceiveNoteCorrectionItemFormContext';

interface ReceiveNoteCorrectionItemBeforeRowProps extends RequiredTestIdProps {
  control: FormControl<ReceiveNoteCorrectionItemForm>;
  formContext: ReceiveNoteCorrectionItemFormContext;
  unit: string;
  currency: string | Nullish;
}

export function ReceiveNoteCorrectionItemBeforeRow(props: ReceiveNoteCorrectionItemBeforeRowProps) {
  const quantity = match(props.formContext)
    .with('receiveItem', always('receiveBeforeQuantity'))
    .with('deliveryItem', always('deliveryBeforeQuantity'))
    .otherwise(always(null));

  const unitPrice = match(props.formContext)
    .with('receiveItem', always('receiveBeforeUnitPrice'))
    .with('deliveryItem', always('deliveryBeforeUnitPrice'))
    .otherwise(always(null));

  const totalPrice = match(props.formContext)
    .with('receiveItem', always('receiveBeforeStockValue'))
    .with('deliveryItem', always('deliveryBeforeStockValue'))
    .otherwise(always(null));

  return (
    <Grid columns={4} spacing={4} align="flex-end" data-testid={props['data-testid']}>
      <GridItem span={1}>
        <FormField
          control={props.control}
          type="number"
          name={`${props.formContext}.${quantity}` as Path<ReceiveNoteCorrectionItemForm>}
          suffix={props.unit}
          isDisabled
          data-testid={suffixTestId('inputs.beforeQuantity', props)}
        />
      </GridItem>
      <GridItem span={1}>
        <FormField
          control={props.control}
          type="number"
          name={`${props.formContext}.${unitPrice}` as Path<ReceiveNoteCorrectionItemForm>}
          suffix={props.currency}
          isDisabled
          data-testid={suffixTestId('inputs.beforeUnitPrice', props)}
        />
      </GridItem>
      <GridItem span={1}>
        <FormField
          control={props.control}
          type="number"
          name={`${props.formContext}.${totalPrice}` as Path<ReceiveNoteCorrectionItemForm>}
          suffix={props.currency}
          isDisabled
          data-testid={suffixTestId('inputs.beforeStockValue', props)}
        />
      </GridItem>
      <GridItem span={1}>
        <HStack spacing={2} align="center">
          <Icon value="navigation/chevron_left" color="palettes.neutral.800" size={4} />
          <Box width="100%">
            <Flag
              label={i18n.t('entity.warehouse.labels.beforeCorrection')}
              colorScheme="red"
              size="large"
              isSubtle
              isFullWidth
              data-testid={suffixTestId('rowFlag', props)}
            />
          </Box>
        </HStack>
      </GridItem>
    </Grid>
  );
}
